// extracted by mini-css-extract-plugin
export var assigneeCell = "_g-b";
export var assigneeList = "_g-c";
export var assigneeName = "_g-d";
export var assigneeOverflow = "_g-e";
export var backLink = "_g-19";
export var badgeWithDate = "_g-11";
export var detailDateMuted = "_g-12";
export var detailEmptyValue = "_g-v";
export var detailGrid = "_g-s";
export var detailHeader = "_g-o";
export var detailLabel = "_g-t";
export var detailPage = "_g-n";
export var detailSection = "_g-q";
export var detailSectionTitle = "_g-r";
export var detailTitle = "_g-p";
export var detailValue = "_g-u";
export var emptyState = "_g-m";
export var exitFeedbackNotes = "_g-10";
export var hubspotCell = "_g-f";
export var hubspotIcon = "_g-h";
export var hubspotLink = "_g-g";
export var infiniteScrollCount = "_g-1c";
export var infiniteScrollFooter = "_g-1b";
export var infiniteScrollManual = "_g-1f";
export var infiniteScrollSentinel = "_g-1g";
export var infiniteScrollSpinner = "_g-1d";
export var jsonFieldGrid = "_g-15";
export var jsonFieldKey = "_g-16";
export var jsonFieldValue = "_g-17";
export var jsonStepKey = "_g-14";
export var jsonViewer = "_g-13";
export var loadMoreWrapper = "_g-l";
export var merchantIconLink = "_g-a";
export var merchantNameCellWrapper = "_g-8";
export var merchantNameHeader = "_g-7";
export var merchantNameLink = "_g-9";
export var onboardingStatusBadge = "_g-1m";
export var overviewPanelStack = "_g-w";
export var pageContent = "_g-1";
export var pageWrapper = "_g-0";
export var paginationButton = "_g-1o";
export var paginationControls = "_g-1k";
export var paginationFooter = "_g-1h";
export var paginationPageLabel = "_g-1p";
export var paginationPageSize = "_g-1l";
export var paginationPager = "_g-1n";
export var paginationSummary = "_g-1i";
export var paginationSummaryText = "_g-1j";
export var replayCell = "_g-i";
export var replayIcon = "_g-k";
export var replayLink = "_g-j";
export var searchInput = "_g-4";
export var settingsArchiveButtonIcon = "_g-z";
export var settingsArchiveButtonRow = "_g-y";
export var settingsPanelStack = "_g-x";
export var statusCell = "_g-5";
export var statusCellBadges = "_g-6";
export var tabContent = "_g-1a";
export var tableWrapper = "_g-2";
export var timelineTable = "_g-18";
export var toolbar = "_g-3";
export var v2InfiniteScrollSpin = "_g-1e";